import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import textWidth from "text-width";
import CriticalEvent from "../../../RelatedInfoPanel/RiPanelAi/FutureEventsIcons/CriticalEvent";
import CompanyAndNewsEvent from "../../../RelatedInfoPanel/RiPanelAi/FutureEventsIcons/CompanyAndNewsEvent";
import ProductAndNewsEvent from "../../../RelatedInfoPanel/RiPanelAi/FutureEventsIcons/ProductAndNewsEvent";
import IndustryEvent from "../../../RelatedInfoPanel/RiPanelAi/FutureEventsIcons/IndustryEvent";
import GovernmentRegulatory from "../../../RelatedInfoPanel/RiPanelAi/FutureEventsIcons/GovernmentRegulatory";
import { AI_FUTURE_EVENT_TYPES } from "../../../../../../Constants/AINewsConstants";
import { Overlay, Popover } from "react-bootstrap";
import AIReactionModal from "../../../../../../RayCustomControls/AIContent/AIReactionModal";
import BaseServiceApi from "BaseServiceApi";
import UserInfoUtil from "UserInfoUtil";
import { setFutureEventReaction } from "../../../../../../Actions/AINewsActions";
import EarningsEvent from "../../../RelatedInfoPanel/RiPanelAi/FutureEventsIcons/EarningsEvent";
import { set } from "lodash";

const EntitlementType = BaseServiceApi.rayData["EntitlementType"];
const HOVER_HIDE_DELAY_MS = 100;
const HOVER_SHOW_DELAY_MS = 100;
const CRITICAL_ROW_HEIGHT = 30;
const DEFAULT_ROW_HEIGHT = 18;

const FutureEventsData = ({ events, dimension, aiSettings, saveReaction, isMiniListOpen }) => {
  const [showPopupId, setShowPopupId] = React.useState(null);
  const [target, setTarget] = React.useState(null);
  const [savedReactions, setSavedReactions] = React.useState({});
  const [lockedEventId, setLockedEventId] = React.useState(null);
  const iconRefs = React.useRef([]);
  const popoverNodeRefs = React.useRef({});
  const hideTimeoutRefs = React.useRef({});
  const showTimeoutRefs = React.useRef({});
  const [reactionModalEventId, setReactionModalEventId] = React.useState(null);
  const handleReactionModalVisibilityChange = React.useCallback((eventId, isOpen) => {
    setReactionModalEventId((prev) => {
      if (isOpen) {
        return eventId;
      }
      return prev === eventId ? null : prev;
    });
  }, []);
  const isAIFeedbackEntitled = UserInfoUtil.IsUserEntitled(
    EntitlementType.AI_FEEDBACK_Entitlement
  );
  const ICON_WIDTH = 20;
  const zoneRows = {
    1: [],
    2: [],
    3: [],
    4: [],
  };
  const clearSavedReactions = React.useCallback(() => setSavedReactions({}), []);
  const handleReaction = (event_name, event_type, sentiment, text, reaction, comments) => {
    setSavedReactions({event_name, event_type, sentiment, text, reaction, comments});
  };
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      const popoverElement = document.getElementById("event-tooltip");
      const reactionPopoverElement = document.getElementById("reaction-popover");
      const clickedInsidePopover = popoverElement && popoverElement.contains(event.target);
      const clickedInsideReaction = reactionPopoverElement && reactionPopoverElement.contains(event.target);
      
      // Check if clicking on an event icon
      const clickedEventIcon = iconRefs.current.some((iconRef) => {
        if (iconRef?.current) {
          try {
            return iconRef.current.contains(event.target) || iconRef.current === event.target;
          } catch (err) {
            return false;
          }
        }
        return false;
      });
      
      if (!clickedInsidePopover && !clickedInsideReaction && !clickedEventIcon) {
        if (savedReactions.reaction) {
          saveReaction(
            savedReactions.event_name,
            savedReactions.event_type,
            savedReactions.sentiment,
            savedReactions.text,
            savedReactions.reaction,
            savedReactions.comments
          );
        }
        clearSavedReactions();
        setShowPopupId(null);
        setTarget(null);
        setLockedEventId(null);
        setReactionModalEventId((prev) =>
          prev === showPopupId ? null : prev
        );
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPopupId, savedReactions, saveReaction, clearSavedReactions]);

  React.useEffect(() => {
    const onDocMouseMove = (e) => {
      let hoveredEventId = null;

      const isWithinArrowBounds = (node) => {
        if (!node) return false;
        const padding = 16;
        const rect = node.getBoundingClientRect();
        const { clientX, clientY } = e;
        return (
          clientX >= rect.left - padding &&
          clientX <= rect.right + padding &&
          clientY >= rect.top - padding &&
          clientY <= rect.bottom + padding
        );
      };
      iconRefs.current.forEach((iconRef) => {
        if (iconRef?.current) {
          const element = iconRef.current;
          try {
            if (element.contains(e.target) || element === e.target) {
              const eventId = element.getAttribute?.('data-event-id');
              if (eventId) {
                hoveredEventId = eventId;
              }
            }
          } catch (err) {
            const closest = e.target.closest?.('[data-event-id]');
            if (closest && closest === element) {
              hoveredEventId = element.getAttribute?.('data-event-id');
            }
          }
        }
      });
      
      Object.keys(popoverNodeRefs.current).forEach((eventId) => {
        const popoverNode = popoverNodeRefs.current[eventId];
        if (popoverNode) {
          try {
            if (
              popoverNode.contains(e.target) ||
              popoverNode === e.target ||
              isWithinArrowBounds(popoverNode)
            ) {
              hoveredEventId = eventId;
            }
          } catch (err) {
            // Ignore errors
          }
        }
      });
      
      if (!hoveredEventId) {
        const reactionPopoverElement = document.getElementById("reaction-popover");
        if (reactionPopoverElement) {
          try {
            if (
              reactionPopoverElement.contains(e.target) ||
              reactionPopoverElement === e.target ||
              isWithinArrowBounds(reactionPopoverElement)
            ) {
              if (showPopupId) {
                hoveredEventId = String(showPopupId);
              }
            }
          } catch (err) {
            // Ignore errors
          }
        }
      }
      events.forEach((event) => {
        const eventIdStr = String(event.id);
        const isHovered = hoveredEventId === eventIdStr;
        const isLocked = lockedEventId === event.id;
        
        if (isHovered) {
          if (hideTimeoutRefs.current[eventIdStr]) {
            clearTimeout(hideTimeoutRefs.current[eventIdStr]);
            hideTimeoutRefs.current[eventIdStr] = null;
          }
          // Only show tooltip on hover if no event is locked, or if this is the locked event
          if (showPopupId !== event.id && !showTimeoutRefs.current[eventIdStr] && (!lockedEventId || lockedEventId === event.id)) {
            showTimeoutRefs.current[eventIdStr] = setTimeout(() => {
              const iconRef = iconRefs.current.find((ref) => 
                ref?.current?.getAttribute?.('data-event-id') === eventIdStr
              );
              if (iconRef?.current) {
                setShowPopupId(event.id);
                setTarget(iconRef.current);
              }
              showTimeoutRefs.current[eventIdStr] = null;
            }, HOVER_SHOW_DELAY_MS);
          }
        } else {
          if (showTimeoutRefs.current[eventIdStr]) {
            clearTimeout(showTimeoutRefs.current[eventIdStr]);
            showTimeoutRefs.current[eventIdStr] = null;
          }
          // Don't hide if the event is locked
          if (showPopupId === event.id && !isLocked) {
            if (reactionModalEventId === event.id) {
              return;
            }
            if (hideTimeoutRefs.current[eventIdStr]) {
              clearTimeout(hideTimeoutRefs.current[eventIdStr]);
            }
            hideTimeoutRefs.current[eventIdStr] = setTimeout(() => {
              // Save reaction before closing popover
              if (savedReactions.reaction) {
                saveReaction(
                  savedReactions.event_name,
                  savedReactions.event_type,
                  savedReactions.sentiment,
                  savedReactions.text,
                  savedReactions.reaction,
                  savedReactions.comments
                );
              }
              clearSavedReactions();
              setShowPopupId(null);
              setTarget(null);
              hideTimeoutRefs.current[eventIdStr] = null;
            }, HOVER_HIDE_DELAY_MS);
          }
        }
      });
    };

    document.addEventListener("mousemove", onDocMouseMove);
    return () => {
      document.removeEventListener("mousemove", onDocMouseMove);
      Object.keys(hideTimeoutRefs.current).forEach((key) => {
        if (hideTimeoutRefs.current[key]) {
          clearTimeout(hideTimeoutRefs.current[key]);
        }
      });
      Object.keys(showTimeoutRefs.current).forEach((key) => {
        if (showTimeoutRefs.current[key]) {
          clearTimeout(showTimeoutRefs.current[key]);
        }
      });
    };
  }, [events, showPopupId, savedReactions, saveReaction, reactionModalEventId, lockedEventId, clearSavedReactions]);

  React.useEffect(() => {
    setLockedEventId(null);
  }, [events]);

  React.useEffect(() => {
    const handleResize = () => {
      if (showPopupId) {
        if (savedReactions.reaction) {
          saveReaction(
            savedReactions.event_name,
            savedReactions.event_type,
            savedReactions.sentiment,
            savedReactions.text,
            savedReactions.reaction,
            savedReactions.comments
          );
        }
        clearSavedReactions();
        setShowPopupId(null);
        setTarget(null);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [showPopupId, savedReactions, saveReaction]);
  events.forEach((event) => {
    const zone = event.zone;
    if (!zoneRows[zone]) {
      zoneRows[zone] = [];
    }
    const ICON_HALF = ICON_WIDTH / 2;
    function getOccupiedRanges(ev) {
      const ranges = [];
      if (ev.xAxis != null) {
        ranges.push([ev.xAxis - ICON_HALF, ev.xAxis + ICON_HALF]);
      }
      if (ev.announedXAxis != null) {
        const start = Math.min(ev.announedXAxis, ev.xAxis);
        const end = Math.max(ev.announedXAxis, ev.xAxis);
        ranges.push([start, end]);
      }
      if (ev.endDateXAxis != null) {
        const start = Math.min(ev.endDateXAxis, ev.xAxis);
        const end = Math.max(ev.endDateXAxis, ev.xAxis);
        ranges.push([start, end]);
      }
      return ranges;
    }

    function rangesOverlap(a, b) {
      const aStart = a[0];
      const aEnd = a[1];
      const bStart = b[0];
      const bEnd = b[1];
      return aStart <= bEnd && bStart <= aEnd;
    }

    let assigned = false;
    for (let row = 0; row < zoneRows[zone].length; row++) {
      const rowEvents = zoneRows[zone][row];
      const isCollision = rowEvents.some((e) => {
        const existingRanges = getOccupiedRanges(e);
        const newRanges = getOccupiedRanges(event);
        return existingRanges.some((r1) =>
          newRanges.some((r2) => rangesOverlap(r1, r2))
        );
      });
      if (!isCollision) {
        rowEvents.push(event);
        event._zoneRow = { zone, row };
        assigned = true;
        break;
      }
    }
    if (!assigned) {
      const newRowIndex = zoneRows[zone].length;
      zoneRows[zone][newRowIndex] = [event];
      event._zoneRow = { zone, row: newRowIndex };
    }
  });
  const zoneOrder = [4, 3, 2, 1];
  const nonEmptyZones = zoneOrder.filter((zone) =>
    zoneRows[zone].some((rowEvents) => rowEvents.length > 0)
  );

  const zoneRowOffsets = {};
  const zoneRowHeights = {};
  const zoneTotalHeights = {};

  nonEmptyZones.forEach((zone) => {
    const rows = zoneRows[zone];
    zoneRowOffsets[zone] = [];
    zoneRowHeights[zone] = [];

    let offset = 0;
    rows.forEach((rowEvents, rowIdx) => {
      zoneRowOffsets[zone][rowIdx] = offset;
      const hasCritical = rowEvents.some(
        (e) => e.type === AI_FUTURE_EVENT_TYPES.CRITICAL
      );
      const height = hasCritical ? CRITICAL_ROW_HEIGHT : DEFAULT_ROW_HEIGHT;
      zoneRowHeights[zone][rowIdx] = height;
      offset += height;
    });

    zoneTotalHeights[zone] = offset || DEFAULT_ROW_HEIGHT;
  });
  const zoneBaseOffset = {};
  let currentOffset = 0;
  nonEmptyZones.forEach((zone) => {
    zoneBaseOffset[zone] = currentOffset;
    currentOffset += zoneTotalHeights[zone];
  });

  const yBase = 60;
  const renderEventIcon = (event, y, zone, row, idx) => {
    const iconRef = iconRefs.current[idx] = iconRefs.current[idx] || React.createRef();
    const baseOffset = zoneBaseOffset[zone] || 0;
    const rowOffset =
      (zoneRowOffsets[zone] && zoneRowOffsets[zone][row]) || 0;
    const iconY = (dimension?.height || 0) - y - baseOffset - rowOffset;
    let placement;
    const totalTextWidth = textWidth(event.note, { family: "calibri", size: 14 });
    const estimatedPopoverHeight = (totalTextWidth / 250) * 17 + 90; // rough estimation
    if (iconY + dimension.top > estimatedPopoverHeight) {
      placement = "top";
    } else {
      placement = "bottom";
    }
    const iconSize = 15;
    const Icons = {
      [AI_FUTURE_EVENT_TYPES.CRITICAL]: (
        <CriticalEvent
          fontSize="15px"
          pointerEvents="all"
          className={`future-event-icon ${event.sentiment?.toLowerCase() || "neutral"}`}
        />
      ),
      [AI_FUTURE_EVENT_TYPES.COMPANY_NEWS]: (
        <CompanyAndNewsEvent
          fontSize="15px"
          pointerEvents="all"
          className={`future-event-icon ${event.sentiment?.toLowerCase() || "neutral"}`}
        />
      ),
      [AI_FUTURE_EVENT_TYPES.PRODUCT_NEWS]: (
        <ProductAndNewsEvent
          fontSize="15px"
          pointerEvents="all"
          className={`future-event-icon ${event.sentiment?.toLowerCase() || "neutral"}`}
        />
      ),
      [AI_FUTURE_EVENT_TYPES.INDUSTRY]: (
        <IndustryEvent
          fontSize="15px"
          pointerEvents="all"
          className={`future-event-icon ${event.sentiment?.toLowerCase() || "neutral"}`}
        />
      ),
      [AI_FUTURE_EVENT_TYPES.GOVERNMENT_REGULATORY]: (
        <GovernmentRegulatory
          fontSize="15px"
          pointerEvents="all"
          className={`future-event-icon ${event.sentiment?.toLowerCase() || "neutral"}`}
        />
      ),
      [AI_FUTURE_EVENT_TYPES.EARNINGS]: (
        <EarningsEvent
          fontSize="15px"
          pointerEvents="all"
          className={`future-event-icon ${event.sentiment?.toLowerCase() || "neutral"}`}
        />
      ),
    };
    
    const renderArrow = () => {
      if (!event.announedXAxis || event.announedXAxis === event.xAxis) {
        return null;
      }
      const arrowY = iconY + iconSize / 2; 
      const startX = event.xAxis-iconSize/2;
      const endX = event.announedXAxis; 
      const arrowHeadSize = 8;
      const arrowHeadPoints = `${startX},${arrowY} ${startX - arrowHeadSize},${arrowY - arrowHeadSize / 2} ${startX - arrowHeadSize},${arrowY + arrowHeadSize / 2}`;
      return (
        startX > endX &&  ( 
        <g>
          { startX - endX > arrowHeadSize &&
            <polygon
              points={arrowHeadPoints}
              className={`future-event-arrow ${event.sentiment?.toLowerCase()}`}
            />
          }
          <line
            x1={startX}
            y1={arrowY}
            x2={endX}
            y2={arrowY}
            strokeWidth={1.5}
            className={`future-event-arrow ${event.sentiment?.toLowerCase()}`}
          />
          <line
            x1={endX}
            y1={arrowY-6}
            x2={endX}
            y2={arrowY+6}
            strokeWidth={1}
            className={`future-event-arrow ${event.sentiment?.toLowerCase()}`}
          />
        </g>
      ));
    };

    const renderEndLine = (event) => {
      if (!event.endDateXAxis || event.endDateXAxis === event.xAxis) {
        return null;
      }
      const arrowY = iconY + iconSize / 2;
      const startX = event.xAxis + iconSize / 2;
      const endX = event.endDateXAxis;
      return (
        <g>
          <line
            x1={startX}
            y1={arrowY}
            x2={endX}
            y2={arrowY}
            strokeWidth={1.5}
            strokeDasharray="4,2"
            className={`future-event-arrow ${event.sentiment?.toLowerCase()}`}
          />
        </g>
      );
    };

    const renderLabel = (event) => {
      if (!event.label) return null;
      const labelWidth = textWidth(event.label, { family: "calibri", size: 14 });
      return (
        <g transform={`translate(${event.xAxis - labelWidth/2}, ${iconY - 4})`}>
          <text
            className={`future-event-label ${event.sentiment?.toLowerCase() || "neutral"}`}
          >
            {event.label}
          </text>
        </g>
      );
    };
    const x = event.xAxis;
    const innerOffset = Math.max(0, 192.5 - ((window.innerWidth - (isMiniListOpen ? 102 : 0)) - (x + 121)));
    const translateX = -90 + innerOffset;

    const renderTooltip = (
      <Popover
        id='event-tooltip'
        className={`event-detail-tooltip ${event.sentiment?.toLowerCase()}`}
        style={{
          maxWidth: "300px",
          fontSize: "14px",
          textAlign: "center",
          alignItems: "center",
        }}
      >
        <div
          ref={(node) => {
            if (node) {
              popoverNodeRefs.current[event.id] = node;
            } else {
              delete popoverNodeRefs.current[event.id];
            }
          }}
          style={{
            position: "relative",
            boxSizing: "border-box",
          }}
          onMouseDown={(e) => e.stopPropagation()} // prevent overlay rootClose from treating this as outside click
        >
          <div style={{ fontWeight: "bold", alignItems: "center", gap: "8px", marginBottom: "4px", position: "relative" }}>
            {moment(event.date).format("MMM D, YYYY")}
              {isAIFeedbackEntitled && (
                <div style={{ top: "0px", position: "absolute", right: "74px" }}>
                  <AIReactionModal
                    text={event.note}
                    handleReaction={(text, reaction, comments) =>
                      handleReaction(
                        event.name,
                        event.type,
                        event.sentiment,
                        text,
                        reaction,
                        comments
                      )
                    }
                    stopTranslate={true}
                    parentText=""
                    translateX={translateX}
                    arrowTransformX={72}
                    onVisibilityChange={(isOpen) =>
                      handleReactionModalVisibilityChange(event.id, isOpen)
                    }
                  />
                </div>
              )}
          </div>
          <div>{event.note}</div>
        </div>
      </Popover>
    );
    const isTooltipVisible = showPopupId === event.id || lockedEventId === event.id;
    const groupClassName = `future-event-group${isTooltipVisible ? " tooltip-visible" : ""}`;

    const iconElement = (event.type == 1 && event.label == "ER") ? Icons["6"] : Icons[event.type];
    return (
      <g className={groupClassName} key={event.id}>
        {renderArrow()}
        {renderEndLine(event)}
        {renderLabel(event)}
        <g
          key={event.id}
          ref={iconRef}
          data-event-id={event.id}
          className="future-event-icon-wrap"
          transform={`translate(${event.xAxis - iconSize/2}, ${iconY})`}
          pointerEvents="all"
          stroke="transparent"
          data-disable-track-price="true"
          onClick={(e) => {
            e.stopPropagation();
            const eventId = event.id;
            if (lockedEventId === eventId) {
              // If already locked, unlock it
              setLockedEventId(null);
              if (showPopupId === eventId) {
                // Close the tooltip if it's open
                if (savedReactions.reaction) {
                  saveReaction(
                    savedReactions.event_name,
                    savedReactions.event_type,
                    savedReactions.sentiment,
                    savedReactions.text,
                    savedReactions.reaction,
                    savedReactions.comments
                  );
                }
                clearSavedReactions();
                setShowPopupId(null);
                setTarget(null);
              }
            } else {
              // Lock this event and show tooltip
              setLockedEventId(eventId);
              if (showPopupId !== eventId) {
                setShowPopupId(eventId);
                setTarget(iconRef.current);
              }
            }
          }}
        >
          {iconElement}
        </g>
        { (showPopupId === event.id || lockedEventId === event.id) &&
          <Overlay
            show={showPopupId === event.id || lockedEventId === event.id}
            target={target}
            placement={placement}
            rootClose={false}
          >
            {renderTooltip}
          </Overlay>
        }
      </g>
    );
  };
  return (
    aiSettings?.futureEvent.isVisible ? (
      <div className="edu-in-price-chart">
        <svg
          id="future-events"
          width={dimension.width}
          height={dimension.height}
          pointerEvents="all"
        >
          {events.map((event, idx) => {
            const { zone, row } = event._zoneRow || { zone: event.zone, row: 0 };
            return renderEventIcon(event, yBase, zone, row, idx);
          })}
        </svg>
      </div>
    ) : <></>
  );
};

const mapStateToProps = ({ aiNewsReducer, DatagraphReducers, RelatedInfoPanelReducers }) => {
  const { dimension, HiLowPoints } = DatagraphReducers.PriceChartReducer;
  const events = aiNewsReducer.futureEvents || [];
  const { aiSettings } = RelatedInfoPanelReducers.RiPanelAI;
  const { isMiniListOpen } = DatagraphReducers.DataGraphReducer;
  return { events, dimension, aiSettings, HiLowPoints, isMiniListOpen };
};

const mapDispatchToProps = (dispatch) => ({
  showExternalInfoText: (infobox) => dispatch(showExternalInfoText(infobox)),
  saveReaction: (event_name, event_type, sentiment, feedback_description, feedback_type, comment) =>
      dispatch(setFutureEventReaction(event_name, event_type, sentiment, feedback_description, feedback_type, comment)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FutureEventsData);
